import React from 'react';
import { ProductBlock } from 'src/components/AtbModal/ProductBlock';
import { ProductSummary } from 'src/components/Basket/utils/basket-customisations';

import classes from './Summary.scss';

type Props = {
    products: ProductSummary[];
};

export const SummaryList: React.FC<Props> = (props) => {
    return (
        <div className={classes.summaryList}>
            {props.products.map((product) => {
                const { sku, name, items, image } = product;
                return <ProductBlock key={sku} product={{ items, name, image, sku }} />;
            })}
        </div>
    );
};
